import ForwardArrowIcon from 'assets/svgs/ForwardArrow';
import classNames from 'classnames';
import { maxWidth, primaryColor, retina, secondaryFont, wMBold } from 'constants/utilsStyles';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled(Link)`
  &.viewLessSwitch {
    .forward-arrow-icon {
      transform: scale(-1, 1);
      margin-left: 0px;
      margin-right: 10px;
    }
  }
  display: inline-flex;
  align-items: center;
  font-family: ${secondaryFont};
  font-weight: ${wMBold};
  font-size: 16px;
  color: ${primaryColor};
  cursor: pointer;
  .forward-arrow-icon {
    width: 15px;
    min-width: 15px;
    height: 15px;
    margin-left: 10px;
  }
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 14px;
    .forward-arrow-icon {
      width: 13px;
      min-width: 13px;
      height: 12px;
    }
  }
`;
type Props = {
  viewSwitch?: boolean,
  redirectLink: string;
  goBackLink: string;
  handleClick?: () => void;
} & typeof defaultProps;

const defaultProps = {
  viewSwitch: false,
};
const ViewSwitcherComponent = function ViewSwitcherComponent(props: Props) {
  const { viewSwitch, redirectLink, goBackLink, handleClick } = props;
  return (
    <Wrapper className={classNames('view-switch-cmp', { viewLessSwitch: viewSwitch })} to={viewSwitch ? goBackLink : redirectLink} {...(handleClick && { onClick: handleClick })}>
      {!viewSwitch ? null : (
        <ForwardArrowIcon fillColor={primaryColor} />
      )
      }
      {viewSwitch ? 'Go Back' : 'See all'}
      {
        viewSwitch ? null : (
          <ForwardArrowIcon fillColor={primaryColor} />
        )
      }
    </Wrapper >
  );
};
ViewSwitcherComponent.defaultProps = defaultProps;
export default ViewSwitcherComponent;
